import { useState } from 'react'
import { useDebounce } from '@wappla/react-hooks'

export default function useSearch(initialSearch) {
    const [search, setSearch] = useState(initialSearch)
    const debouncedSearch = useDebounce(search, 600)
    return [debouncedSearch, setSearch]
}
